import React, { useState } from 'react';
import styled from 'styled-components';
import ReCAPTCHA from 'react-google-recaptcha';

import mdToHtml from '../../util/mdToHtml';
import mailgunSubmitForm from '../../util/mailgunSubmitForm';

import Section from '../global/section';
import Top from '../top';
import Button from '../global/button';
import ErrorMessage from '../global/error-message';

const FormStyle = styled.div`
	text-align: center;
	.md-content {
		margin: 1rem 0 2rem;
		text-align: left;
		em {
			font-family: ${(p) => p.theme.fonts.serifBody};
			margin-top: 1rem;
			display: block;
		}
	}

	.form-container form {
		display: flex;
		flex-wrap: wrap;

		.recaptcha-container {
			width: 100%;
			margin-bottom: 1.5rem;
		}

		input {
			margin-bottom: 0.5rem;
			background-color: ${(p) => p.theme.color.light};
			border: 1px solid ${(p) => p.theme.color.lightGrey};
			padding: 0.5rem 1rem;
			&::placeholder {
				color: ${(p) => p.theme.color.grey};
			}
		}
		textarea {
			margin-bottom: 1.5rem;
			background-color: ${(p) => p.theme.color.light};
			border: 1px solid ${(p) => p.theme.color.lightGrey};
			padding: 0.5rem 1rem;
			resize: none;
			width: 100%;
			height: 6rem;
			&::placeholder {
				color: ${(p) => p.theme.color.grey};
			}
		}

		#name,
		#phone {
			width: calc(33.3% - 0.5rem);
			margin-right: 0.5rem;
		}
		#email {
			width: 33.3%;
		}

		label {
			margin: 0.5rem 0;
		}

		button {
			margin: 0 auto;
		}
		@media all and (max-width: 868px) {
			#name,
			#phone,
			#email {
				width: 100%;
				margin-right: 0;
			}
		}
	}
`;

export default ({ data }) => {
	const { top, title, copy } = data;

	const [message, setMessage] = useState(null);
	const [errorMessage, setErrorMessage] = useState(null);

	return (
		<FormStyle>
			<Section bg="white" id="form">
				<Top color="blue">{top}</Top>
				<h2>{title}</h2>
				<div
					className="md-content"
					dangerouslySetInnerHTML={{
						__html: mdToHtml(copy),
					}}
				/>
				<div className="form-container">
					{message && (
						<div className="thanks">
							<h2>Thanks for submitting.</h2>
							<p>{message}</p>
						</div>
					)}
					{!message && (
						<form
							action="/.netlify/functions/form-submit/"
							onSubmit={(event) =>
								mailgunSubmitForm(event, setMessage, setErrorMessage)
							}
							name="franchising"
						>
							<input type="hidden" name="formName" value="franchising" />
							<label className="hide" htmlFor="interest">
								Interest:
							</label>
							<label className="hide" htmlFor="name">
								Name:
							</label>
							<input
								name="name"
								required
								type="text"
								id="name"
								placeholder="Full Name*"
							/>

							<label className="hide" htmlFor="phone">
								Phone:
							</label>
							<input
								type="text"
								id="phone"
								name="phone"
								placeholder="Phone Number"
							/>

							<label className="hide" htmlFor="email">
								Email:
							</label>
							<input
								required
								type="email"
								id="email"
								name="email"
								placeholder="Email*"
							/>

							<label className="location" htmlFor="location">
								Location of Interest*
							</label>
							<textarea required id="location" name="location" />
							<div className="recaptcha-container">
								<ReCAPTCHA
									sitekey={
										process.env.SITE_RECAPTCHA_KEY
											? process.env.SITE_RECAPTCHA_KEY
											: process.env.GATSBY_RECAPTCHA_SITE
									}
								/>
							</div>
							{errorMessage && (
								<ErrorMessage>
									<span dangerouslySetInnerHTML={{ __html: errorMessage }} />
								</ErrorMessage>
							)}
							<Button size="small" bg="blue" type="submit">
								SUBMIT MESSAGE
							</Button>
						</form>
					)}
				</div>
			</Section>
		</FormStyle>
	);
};
